import { useEffect } from 'react'
import { useAuth } from '@clerk/clerk-react'
import { workspaceService } from '../services/workspaceService'

/**
 * Ends the store's session whenever Clerk says nobody is signed in — the ONE place a sign-out
 * reaches the store (PR #237 round 8).
 *
 * Every sign-out route ends here: the profile menu's `signOut()`, a session that expired or was
 * revoked elsewhere, and a reload that comes back signed out. Each one turns Clerk's loaded
 * state to `isSignedIn: false`, and `workspaceService.logout()` → `clearSession()` then bumps
 * `sessionGeneration`, so a create still in flight for the signed-out user seeds and persists
 * nothing, and the persisted session is wiped.
 *
 * ⚠️ Only once Clerk has LOADED. While it is loading `isSignedIn` is `undefined`, which says
 * nothing about the session — clearing then would sign a reloading user out of their store.
 */
export function EndSessionOnSignOut() {
  const { isLoaded, isSignedIn } = useAuth()
  useEffect(() => {
    if (isLoaded && isSignedIn === false) workspaceService.logout()
  }, [isLoaded, isSignedIn])
  return null
}
